import { cn } from '@/lib/utils'
import { type TourBadgeProps, tourBadgeVariants } from './tour-variants'

export function TourBadge({ children, variant, className }: TourBadgeProps) {
  return <span className={cn(tourBadgeVariants({ variant }), className)}>{children}</span>
}
